import { useEffect, useState } from 'preact/hooks';

// Hash routes keep deep links working on static hosting without server rewrites.
function current(): string {
  const path = location.hash.replace(/^#/, '');
  return path.startsWith('/') ? path : '/';
}

export function useRoute(): string {
  const [path, setPath] = useState(current);
  useEffect(() => {
    const onChange = () => setPath(current());
    addEventListener('hashchange', onChange);
    return () => removeEventListener('hashchange', onChange);
  }, []);
  return path;
}
